__turbopack_context__.v({
  "linear-alternate": "styles-module-scss-module__M176ZG__linear-alternate",
  "skeleton": "styles-module-scss-module__M176ZG__skeleton",
  "skeleton-circle": "styles-module-scss-module__M176ZG__skeleton-circle",
  "skeleton-text": "styles-module-scss-module__M176ZG__skeleton-text",
});
